(() => {
  document.querySelectorAll('[data-lmm-product-description]').forEach(description => {
    const overview = document.querySelector('.lmm-product-overview');
    const opening = description.querySelector('p');
    const normaliseCopy = value => value.replace(/\s+/g, ' ').trim();
    if (overview && opening && normaliseCopy(overview.textContent) === normaliseCopy(opening.textContent)) opening.remove();
    const headings = [...description.children].filter(node => /^H[23]$/.test(node.tagName));
    for (const heading of headings) {
      if (!/^(how to (apply|use)|application|directions|ingredients|frequently asked questions|faqs)\b/i.test(heading.textContent.trim())) continue;
      const detail = document.createElement('details');
      detail.className = 'lmm-product-detail';
      const summary = document.createElement('summary');
      summary.textContent = heading.textContent;
      const body = document.createElement('div');
      let sibling = heading.nextSibling;
      while (sibling && !(sibling.nodeType === 1 && /^H[23]$/.test(sibling.tagName))) {
        const next = sibling.nextSibling;
        body.append(sibling);
        sibling = next;
      }
      detail.append(summary, body);
      heading.replaceWith(detail);
    }
  });
  const search = document.querySelector('[data-lmm-search]');
  if (search) {
    const input = search.querySelector('input[type="search"]');
    const panel = search.querySelector('.lmm-search__results');
    let timer, controller, requestNumber = 0;
    const close = () => { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); };
    const open = () => { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); };
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-NZ', {style:'currency', currency:search.dataset.currency || 'NZD'});
    const normalise = value => String(value || '').toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/l\.\s*a\./g, 'la').replace(/lip\s+liner/g, 'lipliner').replace(/eye\s+liner/g, 'eyeliner').replace(/[^a-z0-9]+/g, ' ').trim();
    const colourAliases = {
      purple:['purple', 'violet', 'plum', 'lavender'], violet:['violet'], plum:['plum'], lavender:['lavender'],
      brown:['brown', 'chocolate'], chocolate:['chocolate'], green:['green', 'mint'], mint:['mint'], blue:['blue', 'cobalt'], cobalt:['cobalt'],
      pink:['pink'], peach:['peach'], orange:['orange'], yellow:['yellow'], red:['red', 'reddish'], reddish:['reddish'],
      black:['black'], white:['white'], silver:['silver'], gold:['gold'], teal:['teal'], grey:['grey', 'gray'], gray:['grey', 'gray']
    };
    const productGroups = [['eyeliner'], ['lipliner'], ['concealer', 'conceal'], ['corrector', 'correcting'], ['pigment', 'mixer'], ['foundation'], ['lipstick'], ['mascara'], ['primer'], ['highlighter'], ['blush']];
    const buildScopedQuery = query => {
      if (/[:"()]/.test(query)) return null;
      const words = normalise(query).split(' ');
      const codes = [...query.matchAll(/\d{3,}/g)].map(match => match[0]);
      const colours = words.filter(word => Object.hasOwn(colourAliases, word)).map(word => colourAliases[word]);
      if (!codes.length && !colours.length) return null;
      const kinds = productGroups.filter(group => group.some(word => words.includes(word)));
      const titleGroup = group => '(' + group.flatMap(word => word === 'eyeliner' ? ['eyeliner', 'eye liner'] : word === 'lipliner' ? ['lipliner', 'lip liner'] : [word]).map(word => 'title:"' + word + '"').join(' OR ') + ')';
      const clauses = codes.map(code => '(title:"' + code + '" OR variants.sku:"' + code + '" OR variants.barcode:"' + code + '")');
      clauses.push(...colours.map(titleGroup), ...kinds.map(titleGroup));
      const ignored = ['nz', 'new', 'zealand', 'makeup', 'make', 'up', 'cosmetics', 'colour', 'color'];
      for (const word of words) {
        if (!word || ignored.includes(word) || /\d{3,}/.test(word) || Object.hasOwn(colourAliases, word) || kinds.some(group => group.includes(word))) continue;
        clauses.push('title:"' + word + '"');
      }
      return clauses.join(' AND ');
    };
    const searchUrl = (query, broader = false) => {
      const url = new URL(search.dataset.searchUrl, location.origin), scoped = broader ? null : buildScopedQuery(query);
      url.searchParams.set('q', scoped || query);
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', scoped ? 'none' : 'last');
      url.searchParams.set('options[unavailable_products]', 'last');
      if (scoped) { url.searchParams.set('lmm_query', query); url.searchParams.set('lmm_mode', 'precise'); }
      if (broader) url.searchParams.set('lmm_mode', 'broad');
      return url;
    };
    document.querySelectorAll('[data-lmm-search] form, [data-lmm-search-form]').forEach(form => form.addEventListener('submit', event => {
      const query = form.querySelector('[name="q"]')?.value.trim();
      if (!query || !buildScopedQuery(query)) return;
      event.preventDefault();
      location.assign(searchUrl(query).href);
    }));
    const searchPage = document.querySelector('[data-lmm-search-page]');
    if (searchPage) {
      const currentUrl = new URL(location.href), original = currentUrl.searchParams.get('lmm_query');
      if (original && buildScopedQuery(original) === currentUrl.searchParams.get('q')) {
        input.value = original;
        searchPage.querySelectorAll('[name="q"]').forEach(field => { field.value = original; });
        searchPage.querySelectorAll('[data-lmm-query-message]').forEach(message => { message.textContent = message.dataset.lmmQueryMessage.replace('__LMM_QUERY__', original); });
        const broaden = searchPage.querySelector('[data-lmm-broaden]');
        if (broaden) { broaden.href = searchUrl(original, true).href; broaden.hidden = false; }
        searchPage.querySelectorAll('.Pagination a').forEach(link => { const url = new URL(link.href); url.searchParams.set('lmm_query', original); url.searchParams.set('lmm_mode', 'precise'); link.href = url.href; });
        document.title = document.title.replace(currentUrl.searchParams.get('q'), original);
      }
    }
    const selectProducts = (items, query) => {
      const queryWords = normalise(query).split(' ');
      const codes = [...query.matchAll(/\d{3,}/g)].map(match => match[0]);
      const colours = queryWords.filter(word => Object.hasOwn(colourAliases, word)).map(word => colourAliases[word]);
      const productKinds = productGroups.filter(group => group.some(word => queryWords.includes(word)));
      const importantWords = queryWords.filter(word => !['nz', 'new', 'zealand', 'makeup', 'make', 'up', 'cosmetics', 'colour', 'color'].includes(word));
      return items.map((product, index) => {
        const words = normalise(product.title).split(' ');
        const titleCodes = [...String(product.title).matchAll(/\d{3,}/g)].map(match => match[0]);
        const codeMatch = codes.every(code => titleCodes.includes(code));
        const colourMatch = colours.every(group => group.some(word => words.includes(word)));
        const kindMatch = productKinds.every(group => group.some(word => words.includes(word)));
        const titleMatch = importantWords.length > 0 && importantWords.every(word => words.includes(word));
        return {product, index, keep:codeMatch && colourMatch && (!colours.length || kindMatch), titleMatch};
      }).filter(item => item.keep).sort((a, b) => Number(a.product.available === false) - Number(b.product.available === false) || Number(b.titleMatch) - Number(a.titleMatch) || a.index - b.index).slice(0, 6).map(item => item.product);
    };
    input.addEventListener('input', () => {
      clearTimeout(timer);
      controller?.abort();
      close();
      const query = input.value.trim(), serial = ++requestNumber;
      if (query.length < 2) { close(); panel.replaceChildren(); return; }
      timer = setTimeout(async () => {
        controller = new AbortController();
        const url = new URL(search.dataset.suggestUrl + '.json', location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '10');
        url.searchParams.set('resources[options][unavailable_products]', 'last');
        try {
          const response = await fetch(url, {signal:controller.signal, credentials:'same-origin'});
          if (!response.ok) throw new Error('Search unavailable');
          const data = await response.json();
          if (serial !== requestNumber || document.activeElement !== input) return;
          panel.replaceChildren();
          panel.setAttribute('aria-label', search.dataset.resultLabel);
          const products = selectProducts(data.resources?.results?.products || [], query);
          for (const product of products) {
            const link = document.createElement('a'); link.className = 'lmm-search__result'; link.href = product.url;
            const image = document.createElement('img'); image.alt = ''; image.width = 54; image.height = 54;
            const imageSource = typeof product.image === 'string' ? product.image : product.featured_image?.url;
            if (imageSource) { const imageUrl = new URL(imageSource, location.origin); imageUrl.searchParams.set('width', '108'); image.src = imageUrl.href; }
            const copy = document.createElement('span'), title = document.createElement('strong'), availability = document.createElement('small');
            title.textContent = product.title; availability.textContent = product.available ? search.dataset.inStock : search.dataset.soldOut;
            copy.append(title, availability);
            const price = document.createElement('span'); const amount = Number(product.price);
            if (Number.isFinite(amount)) price.textContent = money.format(amount);
            link.append(image, copy, price); panel.append(link);
          }
          if (!products.length) { const empty = document.createElement('p'); empty.textContent = search.dataset.noResults; empty.style.padding = '12px'; panel.append(empty); }
          const all = document.createElement('a'), resultsUrl = searchUrl(query);
          all.href = resultsUrl.href; all.className = 'lmm-search__all'; all.textContent = search.dataset.viewAll; panel.append(all); open();
        } catch (error) { if (error.name !== 'AbortError' && serial === requestNumber) close(); }
      }, 220);
    });
    input.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); if (event.key === 'ArrowDown' && !panel.hidden) { event.preventDefault(); panel.querySelector('a')?.focus(); } });
    panel.addEventListener('keydown', (event) => { const links = [...panel.querySelectorAll('a')], position = links.indexOf(document.activeElement); if (event.key === 'Escape') { close(); input.focus(); } if (event.key === 'ArrowDown') { event.preventDefault(); links[Math.min(position + 1, links.length - 1)]?.focus(); } if (event.key === 'ArrowUp') { event.preventDefault(); if (position <= 0) input.focus(); else links[position - 1]?.focus(); } });
    search.addEventListener('focusout', () => setTimeout(() => { if (!search.contains(document.activeElement)) close(); }, 0));
    document.addEventListener('click', (event) => { if (!search.contains(event.target)) close(); });
    input.addEventListener('focus', () => { if (panel.childElementCount && input.value.trim().length > 1) open(); });
  }
  document.querySelectorAll('.lmm-nav').forEach(nav => {
    nav.addEventListener('toggle', event => { if (event.target.open) nav.querySelectorAll('details[open]').forEach(other => { if (other !== event.target) other.open = false; }); }, true);
    document.addEventListener('click', event => { if (!nav.contains(event.target)) nav.querySelectorAll('details[open]').forEach(detail => detail.open = false); });
    nav.addEventListener('keydown', event => { if (event.key === 'Escape') { const detail = event.target.closest('details'); if (detail) { detail.open = false; detail.querySelector('summary').focus(); } } });
  });
  document.querySelectorAll('.lmm-category[href^="#"]').forEach(link => link.addEventListener('click', () => { const detail = document.getElementById(link.hash.slice(1)); if (detail) detail.open = true; }));
  let toastTimer;
  document.addEventListener('product:added', () => {
    let toast = document.querySelector('.lmm-toast');
    if (!toast) { toast = document.createElement('div'); toast.className = 'lmm-toast'; toast.setAttribute('role', 'status'); toast.setAttribute('aria-live', 'polite'); document.body.append(toast); }
    toast.textContent = search?.dataset.added || '';
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toast.hidden = true; }, 3500);
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-lmm-quick-add]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button'), status = form.querySelector('[role="status"]'), initial = button.textContent;
    button.disabled = true; button.setAttribute('aria-busy', 'true'); status.textContent = '';
    try {
      const response = await fetch(form.action.replace(/\/add\/?$/, '/add.js'), {method:'POST',credentials:'same-origin',headers:{'Accept':'application/json'},body:new FormData(form)});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || form.dataset.error);
      status.textContent = form.dataset.success;
      document.dispatchEvent(new CustomEvent('product:added', {bubbles:true,detail:{variant:result,quantity:1}}));
      document.querySelectorAll('.Header__CartDot').forEach(dot => dot.classList.add('is-visible'));
    } catch (error) { status.textContent = error.message || form.dataset.error; }
    finally { button.disabled = false; button.removeAttribute('aria-busy'); button.textContent = initial; }
  });
})();
